import React from 'react';
import { useI18n } from '../hooks/useI18n';

const GameSummaryBar = ({ gameInfo, heroInfo, onEdit, onShare }) => {
  const { t, noTranslate } = useI18n();
  
  const convertSuitToSymbol = (suit) => {
    switch (suit.toLowerCase()) {
      case 's': return '♠️';
      case 'h': return '♥️';
      case 'd': return '♦️';
      case 'c': return '♣️';
      default: return suit;
    }
  };
  
  const formatHand = (hand) => {
    return hand.map(card => {
      const value = card[0];
      const suit = card[1];
      return value + convertSuitToSymbol(suit);
    }).join(' ');
  };
  
  return (
    <div className="bg-white rounded-lg shadow-sm mb-6 p-4">
      <div className="flex justify-between h-full">
        <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
          <div className="text-gray-700 text-base font-medium mb-1 sm:mb-0">
            {gameInfo.stakes} <span className="sm:hidden">{t('game.nlhe')}</span> <span className="hidden sm:inline">No-Limit Hold'em</span> ({gameInfo.players} {t('game.handed')})
          </div>
          <span className="hidden sm:inline text-gray-500">•</span>
          <div className="text-gray-600 text-[15px]">
            Hero: {noTranslate(heroInfo.position)} {formatHand(heroInfo.hand)}
          </div>
        </div>
        <div className="flex items-center space-x-2 ml-4 self-center">
          <button
            onClick={onEdit}
            className="text-gray-500 hover:text-gray-700 p-1"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-[18px] w-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </button>
          <button
            onClick={onShare}
            className="flex items-center space-x-1.5 px-4 py-1.5 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition duration-200 text-[14px] font-medium"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-[16px] w-[16px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
            </svg>
            <span>{t('common.share')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameSummaryBar;